import L from "leaflet";

const OSM_TILES = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
const CARTO_TILES =
  "https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}{r}.png";

/**
 * CARTO stamps "API KEY REQUIRED" across every basemap tile it serves without a
 * key, which is what shows through underneath the choropleth. The key stays
 * optional: with none configured the map still draws, watermarked, rather than
 * failing to load, so a missing key never costs more than it did before.
 */
const basemapUrl = (terrain: boolean): string => {
  if (terrain) {
    return OSM_TILES;
  }

  //* CARTO takes the key as a "key" query parameter, see
  //* carto.com/basemaps/apikey
  const apiKey = process.env.REACT_APP_CARTO_API_KEY;
  return apiKey ? `${CARTO_TILES}?key=${apiKey}` : CARTO_TILES;
};

export const mapInitialization = (
  mapRef: any,
  id: string,
  isFullScreen = false,
  terrain = false
) => {
  var container = L.DomUtil.get(id);
  if (container != null) {
    container._leaflet_id = null;
  }

  mapRef.current = L.map(id, {
    zoomControl: false,
    attributionControl: false,
  }).setView(
    isFullScreen ? [36.307339, -126.051611] : [37.5351425, -117.2663035],
    5.5
  );
  L.tileLayer(basemapUrl(terrain), {
    maxZoom: 20,
    minZoom: 5,
  }).addTo(mapRef.current);

  const maxBounds = L.latLngBounds([
    [73, -173.0],
    [14.910669, -55.194935],
  ]);

  mapRef.current.setMaxBounds(maxBounds);
  mapRef.current.on("drag", function () {
    mapRef.current.panInsideBounds(maxBounds, { animate: true });
  });

  return () => {
    mapRef.current.remove();
  };
};
